import Auth from '@/services/AuthService'
import axios from 'axios'
import store from '@/store'
// import moment from 'moment'
import config from '@/config'

const API_URL = config.apiEndpoint

const getDefaultState = () => {
  return {
    packages: null,
    downloadStatus: null,
    dlStatusDetails: null,
    entries: null,
    includePath: null
  }
}

// initial state
const state = getDefaultState()

const mutations = {
  setPackages: (state, packages) => {
    state.packages = packages
  },
  setDownloadStatus: (state, status) => {
    state.downloadStatus = status
  },
  setDlStatusDetails: (state, statusDetails) => {
    state.dlStatusDetails = statusDetails
  },
  setEntries: (state, entries) => {
    state.entries = entries
  },
  setIncludePath: (state, includePath) => {
    state.includePath = includePath
  },
  clearDownloadInfos: state => {
    state.downloadStatus = null
    state.dlStatusDetails = null
    state.entries = null
    state.includePath = null
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetPackagesState (context) {
    context.commit('resetState')
  },
  retrievePackages: async context => {
    try {
      let jwtToken

      try {
        jwtToken = await Auth.getJwtToken()
      } catch (err) {
        await store.dispatch('auth/expiredSessionSignOut')
        return
      }

      const token = ['tk:', jwtToken].join('')

      const url = [API_URL, 'prod/search?term=*'].join('/')

      const config = {
        headers: {
          Auth: token
        }
      }

      const response = await axios.get(url, config)
      context.commit('setPackages', response.data.Items)
    } catch (err) {
      await store.dispatch('auth/expiredSessionSignOut')
    }
  },
  downloadPackage: async (context, { packageId, callbacks }) => {
    if (callbacks.onStart) {
      callbacks.onStart()
    }

    await context.commit('clearDownloadInfos')

    try {
      // // Handler of packages saved on localStorage
      // if (localStorage.getItem(`package-${packageId}-entries`)) {
      //   let entries = JSON.parse(localStorage.getItem(`package-${packageId}-entries`)) || null
      //   let includePath = JSON.parse(localStorage.getItem(`package-${packageId}-entries`)) || null

      //   if (entries.length === 0 && includePath.length === 0) {
      //     context.commit('setDlStatusDetails', 'Non ci sono dataset nel pacchetto')
      //     context.commit('setDownloadStatus', 'unable_to_process')
      //     return
      //   }

      //   if (entries && entries[0]) {
      //     // check link validity
      //     let generatedAt = moment(entries[0].url.split('/')[5].split('X-Amz-Date=')[1].split('&')[0])
      //     let expiresAt = generatedAt.add(Number(entries[0].url.split('/')[5].split('X-Amz-Expires=')[1].split('&')[0]), 'seconds')
      //     let now = moment()

      //     if (expiresAt.diff(now, 'seconds') > 0) {
      //       context.commit('setEntries', entries)
      //       return
      //     }
      //   }
      // }

      let jwtToken

      try {
        jwtToken = await Auth.getJwtToken()
      } catch (err) {
        await store.dispatch('auth/expiredSessionSignOut')
        return
      }

      const token = ['tk:', jwtToken].join('')

      // Add package to cart
      const urlAddToCart = [API_URL, 'prod/cart/new'].join('/')

      const payloadAddToCart = JSON.stringify({
        package_id: packageId
      })

      const config = {
        headers: {
          Auth: token
        }
      }

      await axios.post(urlAddToCart, payloadAddToCart, config)

      if (callbacks.onAddToCart) {
        callbacks.onAddToCart()
      }

      // Checkout cart
      const urlCheckoutCart = [API_URL, 'prod/cart'].join('/')

      const payloadCheckoutCart = JSON.stringify({
        operation: 'checkout',
        format: 'signed-url'
      })

      await axios.post(urlCheckoutCart, payloadCheckoutCart, config)

      if (callbacks.onCheckoutCart) {
        callbacks.onCheckoutCart()
      }

      // Describe cart
      const urlDescribeCart = [API_URL, 'prod/cart'].join('/')
      const responseDescribeCart = await axios.get(urlDescribeCart, config)

      if (callbacks.onDescribeCart) {
        callbacks.onDescribeCart()
      }

      if (responseDescribeCart.data.Items[0]) {
        const cartItemStatus =
          responseDescribeCart.data.Items[0].cart_item_status
        const cartItemStatusDetails =
          responseDescribeCart.data.Items[0].status_details

        context.commit('setDownloadStatus', cartItemStatus)
        context.commit('setDlStatusDetails', cartItemStatusDetails)

        switch (cartItemStatus) {
          case 'unable_to_process':
            context.commit(
              'setDlStatusDetails',
              'Non ci sono dataset nel pacchetto'
            )
            break
        }

        if (cartItemStatus !== 'unable_to_process') {
          const manifestUrl = responseDescribeCart.data.Items[0].url

          // Get manifest
          const result = await axios.get(manifestUrl)

          if (callbacks.onGetManifest) {
            callbacks.onGetManifest()
          }

          // context.commit('setEntries', result.data.entries)
          // context.commit('setIncludePath', result.data.include_path)

          if (
            result.data.include_path &&
            result.data.entries &&
            result.data.include_path.length === 0 &&
            result.data.entries === 0
          ) {
            context.commit('setDownloadStatus', 'unable_to_process')
            context.commit(
              'setDlStatusDetails',
              'Non ci sono dataset nel pacchetto'
            )
          } else {
            context.commit('setEntries', result.data.entries)
            context.commit('setIncludePath', result.data.include_path)
          }
          // localStorage.setItem(`package-${packageId}-entries`, JSON.stringify(result.data.entries))
          // localStorage.setItem(`package-${packageId}-include-path`, JSON.stringify(result.data.includePath))
        }
      }

      // Make sure cart is empty
      responseDescribeCart.data.Items.forEach(async item => {
        const urlRemoveCartItem = [API_URL, 'prod/cart', item.item_id].join(
          '/'
        )

        await axios.delete(urlRemoveCartItem, config)
      })
    } catch (err) {
      // console.error(err)
      context.commit('setDownloadStatus', 'error')

      switch (err.message) {
        case 'invalid session':
          context.commit('setDlStatusDetails', 'Sessione non valida')
          break
        case 'Network Error':
          await store.dispatch('auth/expiredSessionSignOut')
          return
        default:
          context.commit('setDlStatusDetails', err.message)
          break
      }
    }
  }
}

const getters = {
  packages: state => state.packages,
  downloadStatus: state => state.downloadStatus,
  dlStatusDetails: state => state.dlStatusDetails,
  entries: state => state.entries,
  includePath: state => state.includePath
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
